module.exports = __webpack_public_path__ + "static/img/年度最佳新出行.dde02620.png";